/**
 * An animation helper
 *
 * Calls the specified callback each animation frame
 * with the percentage done until the duration runs out.
 * The callback can cancel the animation by returning false.
 *
 * Returns a promise that resolves when the animation is done or cancelled.
 *
 * @param  {Function(pctDone)} Method to be called each animation frame
 * @param  {Number} The duration of the animation
 * @return {Promise}
 */
export function animate(cb, animDuration = 1000) {
	return new Promise(res => {
		const animStart = performance.now();
		const animStep = timestamp => {
			const pctDone = (timestamp - animStart) / animDuration;
			const abortAnim = cb(pctDone) === false;

			if (pctDone <= 1 && !abortAnim) {
				window.requestAnimationFrame(animStep);
			} else {
				res();
			}
		};

		window.requestAnimationFrame(animStep);
	});
}
